module.exports = __webpack_public_path__ + "static/media/details-24-image-4.359b28d9.jpg";